import {
  ChevronLeft,
  ChevronRight,
  Ellipsis,
  Pencil,
  Plus,
  Repeat,
  Search,
  Trash2,
} from 'lucide-react'

interface IconProps {
  size?: number
  strokeWidth?: number
}

export const PlusIcon = ({ size = 16, strokeWidth = 2 }: IconProps) => (
  <Plus size={size} strokeWidth={strokeWidth} aria-hidden />
)

export const TrashIcon = ({ size = 16, strokeWidth = 2 }: IconProps) => (
  <Trash2 size={size} strokeWidth={strokeWidth} aria-hidden />
)

export const PencilIcon = ({ size = 18, strokeWidth = 2 }: IconProps) => (
  <Pencil size={size} strokeWidth={strokeWidth} aria-hidden />
)

export const HolidayIcon = ({ size = 18 }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
    <path
      d="M9.981 14.811L9.514 17.537L11.963 16.25L14.412 17.537L13.944 14.811L15.926 12.879L13.188 12.481L11.963 10L10.738 12.481L8 12.879L9.981 14.811Z"
      fill="currentColor"
    />
    <path
      d="M19 4H17V2H15V4H9V2H7V4H5C3.897 4 3 4.897 3 6V20C3 21.103 3.897 22 5 22H19C20.103 22 21 21.103 21 20V6C21 4.897 20.103 4 19 4ZM19.002 20H5V8H19L19.002 20Z"
      fill="currentColor"
    />
  </svg>
)

export const RepeatIcon = ({ size = 14 }: IconProps) => (
  <Repeat size={size} aria-hidden />
)

export const ChevronLeftIcon = () => (
  <ChevronLeft size={20} strokeWidth={1.5} aria-hidden />
)

export const ChevronRightIcon = () => (
  <ChevronRight size={20} strokeWidth={1.5} aria-hidden />
)

export const EllipsisHorizontalIcon = () => (
  <Ellipsis size={20} strokeWidth={1.5} aria-hidden />
)

export const SearchIcon = ({ size = 16, strokeWidth = 2 }: IconProps) => (
  <Search size={size} strokeWidth={strokeWidth} aria-hidden />
)
